import { AccountingMigrationExternalSystem } from "@common/types/domains/accounting/accountingMigration";

interface IsXeroAsIsTypeReviewParams {
    externalSystem?: AccountingMigrationExternalSystem | null;
    isChartImportedAsIs?: boolean | null;
}

export function isXeroAsIsTypeReview({
    externalSystem,
    isChartImportedAsIs,
}: IsXeroAsIsTypeReviewParams): boolean {
    return (
        isChartImportedAsIs === true &&
        externalSystem === AccountingMigrationExternalSystem.XERO
    );
}
